import { memo } from 'react';
const SvgChevronsLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="chevrons-left_svg__feather chevrons-left_svg__feather-chevrons-left"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m11 17-5-5 5-5M18 17l-5-5 5-5" />
  </svg>
);
const Memo = memo(SvgChevronsLeft);
export default Memo;
